import type { FC } from 'react'

import { classNames } from '@/utils/helpers'

interface Props {
  isOn: boolean
  handleToggle: () => void
  onColor?: string
  className?: string
}

export const AmPmSwitch: FC<Props> = ({ isOn, handleToggle, className }) => {
  const spanClassName =
    'absolute flex items-center justify-center w-[50%] h-full'

  return (
    <label
      className={classNames(
        'text-label-primary relative h-[34px] w-[92px] cursor-pointer rounded-md bg-secondary-100/50 transition-colors dark:bg-secondary-700 dark:text-white',
        className,
      )}
    >
      <input
        checked={isOn}
        onChange={handleToggle}
        className="peer absolute hidden h-0 w-0"
        type="checkbox"
      />
      <div className="absolute left-1 top-1 z-10 h-[26px] w-[39px] rounded-md bg-neutral-default drop-shadow transition-all peer-checked:translate-x-[45px] dark:bg-secondary-400" />
      <div className="relative z-20 h-full text-sm">
        <span
          className={classNames(
            spanClassName,
            'left-0',
            !isOn && 'font-medium',
            'z-50',
          )}
        >
          AM
        </span>
        <span
          className={classNames(
            spanClassName,
            'right-0',
            isOn && 'font-medium ',
            'z-50',
          )}
        >
          PM
        </span>
      </div>
    </label>
  )
}
